import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  sidebar: {
    overflowX: 'visible',
  },
  groupName: {
    font: {
      size: '2.4rem',
      lineHeight: '3.2rem',
      weight: 700,
    },
    margin: {
      bottom: '2.4rem',
    },
  },
  categoryName: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500,
    },
    color: colors.neutral[900],
    margin: [0],
    marginBottom: '0.4rem',
    textTransform: 'uppercase',
  },
  categoryWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: colors.neutral[700],
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    marginBottom: '2.4rem',
  },
};
const createStyles = createUseStyles(styles);

export { createStyles };
